import { Control, Path, useFormContext } from 'react-hook-form'
import { InputProps } from '@/components/form/input/Input'
import React, { MutableRefObject, useRef } from 'react'
import { useOutsideClick } from 'rooks'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/form/Form'

import * as styles from './Input.css'
import { input } from './Input.css'
import clsx from 'clsx'
import { EyeHideIcon } from '@/components/icons/eye-hide-icon'
import { EyeShowIcon } from '@/components/icons/eye-show-icon'

type Props<T> = {
	name: Path<T>
	label?: string
	route?: string
} & InputProps

export const FormPasswordInput = <T extends object>({ label, name, ...props }: Props<T>) => {
	const ref = useRef<HTMLDivElement>(null)
	const [showPassword, toggleShowPassword] = React.useState(false)

	const form = useFormContext<T>()

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		e.preventDefault()
		toggleShowPassword(!showPassword)
	}

	const handleOutsideClick = () => {
		toggleShowPassword(false)
	}

	useOutsideClick(ref as MutableRefObject<HTMLDivElement>, handleOutsideClick)

	return (
		<FormField
			control={form.control as Control}
			name={name}
			render={({ field }) => (
				<FormItem className="flex flex-col gap-xxs">
					{label && <FormLabel>{label}</FormLabel>}
					<FormControl>
						<div ref={ref} className={styles.passwordContainer}>
							<input
								{...field}
								type={showPassword ? 'text' : 'password'}
								placeholder={props.placeholder}
								className={clsx(input({ variant: 'default', size: 'password', shadow: 'none' }))}
							/>
							<button
								type="button"
								className={styles.passwordEye}
								onClick={e => handleClick(e)}
								aria-label={showPassword ? 'Show password' : 'Hide password'}>
								{showPassword ? <EyeHideIcon className={styles.eyeIcon} /> : <EyeShowIcon className={styles.eyeIcon} />}
							</button>
						</div>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
